/* eslint-disable */
export default {
  removeParticipant: 'Supprimer le participant',
  confirmStr1: 'Êtes-vous sûr de vouloir supprimer',
  confirmStr2: 'de cet appel ?',
  remove: 'Retirer',
  cancel: 'Annuler',
  participants: 'Participants',
  participant: 'Participant',
  conferenceCall: 'Conférence téléphonique',
  unknownNumber: 'Anonyme',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
